// Centralized API configuration
// All API URL references should import from this file

// Dynamically detect the API URL based on the current browser location
const getApiUrl = () => {
  // If env variable is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Always use localhost:5000 for development
  return 'http://localhost:5000/api';
};

export const API_URL = getApiUrl();
export const API_BASE_URL = API_URL;

// Socket URL (without /api path)
export const SOCKET_URL = API_URL.replace('/api', '');

// Helper to get full API endpoint
export const getApiEndpoint = (path) => `${API_URL}${path.startsWith('/') ? path : '/' + path}`;

export default API_URL;
